import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=09596e76&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09596e76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09596e76')) {
      api.createRecord('09596e76', component.options)
    } else {
      api.reload('09596e76', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=09596e76&scoped=true", function () {
      api.rerender('09596e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account-settings/Index.vue"
export default component.exports